import React from "react";
import { PROVIDER_STAT_CARDS } from "./providerViewConstants";

function ProviderStatCards({ stats = {}, loading = false }) {
  return (
    <div className="cms-providers-stats-grid">
      {PROVIDER_STAT_CARDS.map((item) => {
        const Icon = item.Icon;
        return (
          <div key={item.key} className="cms-providers-stat-card">
            <div
              className="cms-providers-stat-card-accent"
              style={{ backgroundColor: item.color }}
            />
            <div className="cms-providers-stat-card-body">
              {loading ? (
                <>
                  <div className="cms-providers-stat-skeleton cms-providers-stat-skeleton--icon" />
                  <div className="cms-providers-stat-content">
                    <div className="cms-providers-stat-skeleton cms-providers-stat-skeleton--value" />
                    <div className="cms-providers-stat-skeleton cms-providers-stat-skeleton--label" />
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="cms-providers-stat-icon"
                    style={{ backgroundColor: item.iconBg, color: item.color }}
                  >
                    <Icon size={18} />
                  </div>
                  <div className="cms-providers-stat-content">
                    <p className="cms-providers-stat-value">
                      {(stats[item.key] ?? 0).toLocaleString()}
                    </p>
                    <p className="cms-providers-stat-label">{item.label}</p>
                    <p className="cms-providers-stat-subtitle">{item.subtitle}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ProviderStatCards;
